function initQuantityPresets() {
  document.querySelectorAll('[data-quantity-presets]').forEach(function(container) {
    if (container.hasAttribute('data-initialized')) return;

    var blockItem = container.closest('.product-info__block-item') || container.closest('.product-info__quantity-selector');
    var input = blockItem && blockItem.querySelector('.quantity-selector__input');
    var propertyInput = blockItem && blockItem.querySelector('[data-quantity-preset-property]');
    if (!input) return;

    container.setAttribute('data-initialized', 'true');

    var buttons = container.querySelectorAll('[data-quantity-preset]');

    function syncQuantityProperty() {
      if (propertyInput) {
        propertyInput.value = input.value;
      }
    }

    function syncActiveState() {
      var currentQty = parseInt(input.value, 10);

      buttons.forEach(function(button) {
        var presetQty = parseInt(button.getAttribute('data-quantity-preset'), 10);
        var isSelected = presetQty === currentQty;

        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

        if (isSelected) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });

      syncQuantityProperty();
    }

    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        var qty = parseInt(button.getAttribute('data-quantity-preset'), 10);

        if (typeof input.quantity !== 'undefined') {
          input.quantity = qty;
        } else {
          input.value = String(qty);
        }

        input.dispatchEvent(new Event('change', { bubbles: true }));
        syncActiveState();
      });
    });

    input.addEventListener('change', syncActiveState);
    input.addEventListener('input', syncActiveState);
    syncActiveState();
  });
}

function initializeQuantityPresets() {
  initQuantityPresets();
}

document.addEventListener('DOMContentLoaded', initializeQuantityPresets);
document.addEventListener('shopify:section:load', function() {
  setTimeout(initializeQuantityPresets, 100);
});
document.addEventListener('product:rerender', function() {
  setTimeout(initializeQuantityPresets, 100);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeQuantityPresets);
} else {
  setTimeout(initializeQuantityPresets, 100);
}

/* ========================================
 CART DISCOUNT
 ======================================== */

(function() {
  var isProcessing = false;

  function getSectionsToBundle() {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    if (sectionsToBundle.length === 0) {
      var cartDrawer = document.getElementById('cart-drawer');
      var sectionId = cartDrawer && cartDrawer.getAttribute('data-section-id');
      if (sectionId) sectionsToBundle.push(sectionId);
    }

    return sectionsToBundle;
  }

  async function ensureCartDrawerSection(cartData) {
    var cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return cartData;

    var sectionId = null;
    try {
      var sectionEl = cartDrawer.closest('.shopify-section');
      if (sectionEl && sectionEl.id) {
        sectionId = sectionEl.id.replace('shopify-section-', '');
      }
    } catch (e) {}

    if (!sectionId) return cartData;
    if (cartData.sections && cartData.sections[sectionId]) return cartData;

    var sectionResponse = await fetch(window.Shopify.routes.root + '?section_id=' + encodeURIComponent(sectionId));
    var sectionHtml = await sectionResponse.text();
    if (!cartData.sections) cartData.sections = {};
    cartData.sections[sectionId] = sectionHtml;
    return cartData;
  }

  async function dispatchCartChange(cartData) {
    cartData = await ensureCartDrawerSection(cartData);
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'variant:add',
        cart: cartData
      }
    }));
  }

  function getErrorEl(form) {
    var root = form.closest('[data-cart-discount]');
    return root && root.querySelector('[data-cart-discount-error]');
  }

  function setFormLoading(form, loading) {
    var button = form.querySelector('.cart-discount__button');
    var input = form.querySelector('.cart-discount__input');
    if (button) {
      button.disabled = loading;
      button.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
    if (input) input.disabled = loading;
  }

  function showError(form) {
    var error = getErrorEl(form);
    if (error) error.hidden = false;
  }

  function hideError(form) {
    var error = getErrorEl(form);
    if (error) error.hidden = true;
  }

  function codeMatches(a, b) {
    return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
  }

  async function updateCartDiscount(discountValue) {
    var sectionsToBundle = getSectionsToBundle();
    var response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        discount: discountValue,
        sections: sectionsToBundle
      })
    });

    if (!response.ok) {
      throw new Error('Failed to update discount');
    }

    return response.json();
  }

  async function applyDiscount(form, discountCode) {
    var cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
    var existingCodes = (cart.discount_codes || [])
      .filter(function(entry) { return entry && entry.applicable; })
      .map(function(entry) { return entry.code; });

    var nextCodes = existingCodes.filter(function(code) { return !codeMatches(code, discountCode); });
    nextCodes.push(discountCode);

    var data = await updateCartDiscount(nextCodes.join(','));
    var applied = (data.discount_codes || []).find(function(entry) {
      return codeMatches(entry.code, discountCode) && entry.applicable;
    });

    if (!applied) {
      throw new Error('Invalid discount code');
    }

    var input = form.querySelector('.cart-discount__input');
    if (input) input.value = '';
    await dispatchCartChange(data);
  }

  async function removeDiscount(discountCode) {
    var cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
    var remaining = (cart.discount_codes || [])
      .filter(function(entry) {
        return entry && entry.applicable && !codeMatches(entry.code, discountCode);
      })
      .map(function(entry) { return entry.code; });

    var data = await updateCartDiscount(remaining.length ? remaining.join(',') : '');
    await dispatchCartChange(data);
  }

  document.addEventListener('submit', function(event) {
    var form = event.target && event.target.closest && event.target.closest('[data-cart-discount-form]');
    if (!form) return;

    event.preventDefault();
    if (isProcessing) return;

    var input = form.querySelector('.cart-discount__input');
    var discountCode = input && input.value ? input.value.trim() : '';
    if (!discountCode) return;

    isProcessing = true;
    setFormLoading(form, true);
    hideError(form);

    applyDiscount(form, discountCode)
      .catch(function() {
        showError(form);
      })
      .finally(function() {
        isProcessing = false;
        setFormLoading(form, false);
      });
  });

  document.addEventListener('click', function(event) {
    var button = event.target && event.target.closest && event.target.closest('[data-cart-discount-remove]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (isProcessing) return;

    var badge = button.closest('[data-discount-code]');
    var discountCode = badge && badge.getAttribute('data-discount-code');
    if (!discountCode) return;

    isProcessing = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    removeDiscount(discountCode)
      .catch(function(error) {
        console.error('Failed to remove discount:', error);
      })
      .finally(function() {
        isProcessing = false;
        button.disabled = false;
        button.setAttribute('aria-busy', 'false');
      });
  });

  document.addEventListener('input', function(event) {
    var input = event.target && event.target.closest && event.target.closest('.cart-discount__input');
    if (!input) return;
    var form = input.closest('[data-cart-discount-form]');
    if (form) hideError(form);
  });

  var saleCodeApply = null;
  var saleCodeDirty = false;

  function blackweekCode() {
    return document.documentElement.getAttribute('data-blackweek-code') || '';
  }

  function rememberDiscountSession(code) {
    try {
      sessionStorage.setItem('bk-bw-code', code);
    } catch (error) {}
  }

  function discountSessionReady(code) {
    try {
      return sessionStorage.getItem('bk-bw-code') === code;
    } catch (error) {
      return false;
    }
  }

  function primeDiscountSession(code) {
    if (discountSessionReady(code)) return Promise.resolve();
    return fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(code), {
      credentials: 'same-origin',
      redirect: 'manual'
    }).then(function(response) {
      if (response.type === 'opaqueredirect' || response.ok) rememberDiscountSession(code);
    }).catch(function() {});
  }

  function ensureBlackweekCode() {
    var code = blackweekCode();
    if (!code || isProcessing) return Promise.resolve();
    if (saleCodeApply) {
      saleCodeDirty = true;
      return saleCodeApply;
    }

    saleCodeApply = (async function() {
      try {
        var primed = false;
        do {
          saleCodeDirty = false;
          var cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
          var entries = cart.discount_codes || [];
          var present = entries.some(function(entry) {
            return entry && codeMatches(entry.code, code);
          });
          var otherCodes = entries.some(function(entry) {
            return entry && entry.applicable && entry.code && !codeMatches(entry.code, code);
          });
          if (!otherCodes && !primed) {
            primed = true;
            await primeDiscountSession(code);
            saleCodeDirty = true;
            continue;
          }

          if (present) continue;

          var nextCodes = entries
            .filter(function(entry) { return entry && entry.applicable && entry.code; })
            .map(function(entry) { return entry.code; });
          nextCodes.push(code);

          var data = await updateCartDiscount(nextCodes.join(','));
          var applied = (data.discount_codes || []).some(function(entry) {
            return entry && codeMatches(entry.code, code);
          });
          if (applied && (data.item_count || 0) > 0) {
            await dispatchCartChange(data);
          }
        } while (saleCodeDirty);
      } catch (error) {
      } finally {
        saleCodeApply = null;
      }
    })();

    return saleCodeApply;
  }

  document.addEventListener('cart:change', function() {
    ensureBlackweekCode();
  });
  document.addEventListener('variant:add', function() {
    ensureBlackweekCode();
  });

  ensureBlackweekCode();
})();

function applySearchDrawerQuery(query) {
  const input = document.querySelector('#search-drawer input[name="q"]');
  if (!input || !query) return;
  input.value = query;
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.focus();
}

function openPendingSearchDrawer() {
  let pendingQuery = '';
  try {
    pendingQuery = sessionStorage.getItem('bk-media-open-search') || '';
    if (pendingQuery) sessionStorage.removeItem('bk-media-open-search');
  } catch (error) {}

  const searchForm = document.querySelector('#search-drawer form[role="search"]');
  if (searchForm) {
    searchForm.addEventListener('submit', (event) => event.preventDefault());
  }

  if (!pendingQuery) return;

  const toggle = document.querySelector('[aria-controls="search-drawer"]');
  if (toggle) toggle.click();
  applySearchDrawerQuery(pendingQuery);
}

document.addEventListener('click', function(event) {
  const queryLink = event.target && event.target.closest && event.target.closest('.bk-media-search-query');
  if (!queryLink) return;

  event.preventDefault();
  let query = '';
  try {
    query = new URL(queryLink.href, window.location.origin).searchParams.get('q') || '';
  } catch (error) {}
  if (!query) query = (queryLink.textContent || '').trim();
  applySearchDrawerQuery(query);
});

document.addEventListener('DOMContentLoaded', openPendingSearchDrawer);
